const data = {
  id: 1,
  title: 'Read and match',
  subTitle: 'Đọc và nối',
  question: '',
  answers: [
    {
      id: 1,
      textLeft: '1. What nationality are you?',
      textRight: 'c. I’m Vietnamese.',
    },
    {
      id: 2,
      textLeft: '2. When’s your birthday?',
      textRight: 'b. It’s on the 2nd of May.',
    },
    {
      id: 3,
      textLeft: '3. What can you do?',
      textRight: 'a. I can swim.',
    },
  ],
  settings: { // Tùy chọn, có cũng được, không có cũng được.
    showTitleColumn: false, // Hiển thị cột A, B.
    isDragAColumnDisabled: true, // True: không cho phép kéo/thả. False|null|undifined: cho phép kéo/thả.
    // isDragBColumnDisabled: false,
  },
};

export default data;
